//inject

require('./app/app.js');

require('./components/breadcrumb/breadcrumb.tpl.js');

require('./components/common/constants/accountprovider.js');

require('./components/common/constants/defaultI18n.js');

require('./components/common/constants/ngConstants.js');

require('./components/common/directives/clearInputDirective.js');

require('./components/common/directives/contextMenuDirective.js');

require('./components/common/directives/deleteDirective.js');

require('./components/common/directives/driverWrkHrsSvgInterpreter.js');

require('./components/common/directives/header/header-nav.component.js');

require('./components/common/directives/header/header-nav.component.tpl.js');

require('./components/common/directives/iframeOnLoadDirective.js');

require('./components/common/directives/iframeWindowHeightDiretive.js');

require('./components/common/directives/inputNumberValidate.js');

require('./components/common/directives/loadingAnimationDirective.js');

require('./components/common/directives/loadingAnimationDirective.tpl.js');

require('./components/common/directives/noAuthorize.tpl.js');

require('./components/common/directives/noAuthorizeDirective.js');

require('./components/common/directives/noDataAvailable.tpl.js');

require('./components/common/directives/noDataAvailableDirective.js');

require('./components/common/directives/phoneInput.js');

require('./components/common/directives/shortcut.js');

require('./components/common/directives/tachoEventGraphicD3Directive.js');

require('./components/common/directives/toastErrorController.js');

require('./components/common/directives/toastErrorTemplate.tpl.js');

require('./components/common/filters/trustAsResourceUrl.js');

require('./components/common/services/admframework.service.js');

require('./components/common/services/customerService.js');

require('./components/common/services/ErrorHandlingService.js');

require('./components/common/services/messageService.js');

require('./components/common/services/stateManagerService.js');

require('./components/common/services/toastService.js');

require('./components/common/services/trackCommonService.js');

require('./components/common/services/updaterService.js');

require('./components/dashboard/dashboard.js');

require('./components/dashboard/deviceSummary/deviceSummaryEdit.tpl.js');

require('./components/dashboard/deviceSummary/deviceSummaryWidget.js');

require('./components/dashboard/deviceSummary/deviceSummaryWidget.tpl.js');

require('./components/dashboard/digitalOutputs/digitalOutputsWidget.js');

require('./components/dashboard/digitalOutputs/digitalOutputsWidget.tpl.js');

require('./components/dashboard/driverDashboard/driverDashboard.js');

require('./components/dashboard/driverDashboard/driverDashboard.tpl.js');

require('./components/dashboard/driverDashboard/driverDashboardController.js');

require('./components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidget.js');

require('./components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidget.tpl.js');

require('./components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidgetEdit.tpl.js');

require('./components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidget.js');

require('./components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidget.tpl.js');

require('./components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidgetEdit.tpl.js');

require('./components/dashboard/driverWorkingHours/driverWorkingHoursWidget.js');

require('./components/dashboard/driverWorkingHours/driverWorkingHoursWidget.tpl.js');

require('./components/dashboard/driverWorkingHours/driverWorkingHoursWidgetEdit.tpl.js');

require('./components/dashboard/fleetMap/fleetMapEdit.tpl.js');

require('./components/dashboard/fleetMap/fleetMapWidget.js');

require('./components/dashboard/fleetMap/fleetMapWidget.tpl.js');

require('./components/dashboard/fmsDashboard/fmsDashboard.js');

require('./components/dashboard/fmsDashboard/fmsDashboard.tpl.js');

require('./components/dashboard/fmsDashboard/fmsDashboardController.js');

require('./components/dashboard/fmsVehicle/fmsVehicleWidget.js');

require('./components/dashboard/fmsVehicle/fmsVehicleWidget.tpl.js');

require('./components/dashboard/fmsVehicle/fmsVehicleWidgetEdit.tpl.js');

require('./components/dashboard/pendingCommands/pendingCommandsWidget.js');

require('./components/dashboard/pendingCommands/pendingCommandsWidget.tpl.js');

require('./components/dashboard/portalCommand/portalCommand.js');

require('./components/dashboard/portalCommand/portalCommand.tpl.js');

require('./components/dashboard/portalCommand/portalCommandController.js');

require('./components/dashboard/tachoDownloadDashboard/tachoDownloadDashboard.js');

require('./components/dashboard/tachoDownloadDashboard/tachoDownloadDashboard.tpl.js');

require('./components/dashboard/tachoDownloadDashboard/tachoDownloadDashboardController.js');

require('./components/dashboard/tachoDownloadStatus/tachoDownloadStatusWidget.js');

require('./components/dashboard/tachoDownloadStatus/tachoDownloadStatusWidget.tpl.js');

require('./components/dashboard/tachoDownloadStatus/tachoDownloadStatusWidgetEdit.tpl.js');

require('./components/dashboard/tachoEventDetails/tachoEventDetailWidget.js');

require('./components/dashboard/tachoEventDetails/tachoEventDetailWidget.tpl.js');

require('./components/dashboard/tachoEventDetails/tachoEventDetailWidgetEdit.tpl.js');

require('./components/dashboard/tachoHistory/tachoHistoryWidget.js');

require('./components/dashboard/tachoHistory/tachoHistoryWidget.tpl.js');

require('./components/dashboard/tachoHistory/tachoHistoryWidgetEdit.tpl.js');

require('./components/dashboard/tachoHistoryDashboard/tachoHistoryDashboard.js');

require('./components/dashboard/tachoHistoryDashboard/tachoHistoryDashboard.tpl.js');

require('./components/dashboard/tachoHistoryDashboard/tachoHistoryDashboardController.js');

require('./components/dashboard/trackDashboard.tpl.js');

require('./components/dashboard/trackDashboardController.js');

require('./components/dashboard/vehicle/vehicleListEdit.tpl.js');

require('./components/dashboard/vehicle/vehicleListWidget.js');

require('./components/dashboard/vehicle/vehicleListWidget.tpl.js');

require('./components/dashboard/vehicleDetails/vehicleDetailEdit.tpl.js');

require('./components/dashboard/vehicleDetails/vehicleDetailWidget.js');

require('./components/dashboard/vehicleDetails/vehicleDetailWidget.tpl.js');

require('./components/dashboard/vehicleMap/vehicleMapEdit.tpl.js');

require('./components/dashboard/vehicleMap/vehicleMapWidget.js');

require('./components/dashboard/vehicleMap/vehicleMapWidget.tpl.js');

require('./components/dashboard/vehicles/vehiclesListEdit.tpl.js');

require('./components/dashboard/vehicles/vehiclesListWidget.js');

require('./components/dashboard/vehicles/vehiclesListWidget.tpl.js');

require('./components/dashboard/vehicleStatus/vehicleStatusDialog.tpl.js');

require('./components/dashboard/vehicleStatus/vehicleStatusDialogController.js');

require('./components/dashboard/vehicleStatus/vehicleStatusWidget.js');

require('./components/dashboard/vehicleStatus/vehicleStatusWidget.tpl.js');

require('./components/footerbar.tpl.js');

require('./components/footerbar/footerbar.tpl.js');

require('./components/footerbar/footerbarController.js');

require('./components/framework/framework.controller.js');

require('./components/framework/framework.tpl.js');

require('./components/home/home.route.js');

require('./components/home/home.tpl.js');

require('./components/home/homeController.js');

require('./components/login/login.route.js');

require('./components/login/login.tpl.js');

require('./components/login/loginController.js');

require('./components/login/logout.route.js');

require('./components/login/logoutController.js');

require('./components/login/passwordController.js');

require('./components/login/pswdChange.tpl.js');

require('./components/navbar/commandController.js');

require('./components/navbar/commands.tpl.js');

require('./components/sidebar/sidebar.tpl.js');

require('./components/sidebar/sideBarController.js');

require('./components/track/admin/bookDownload.tpl.js');

require('./components/track/admin/bookManagement.js');

require('./components/track/admin/bookManagementAddEdit.tpl.js');

require('./components/track/admin/bookManagementList.tpl.js');

require('./components/track/admin/contactFileImport.tpl.js');

require('./components/track/admin/contactManagement.js');

require('./components/track/admin/contactManagement.tpl.js');

require('./components/track/admin/contactManagementAddEdit.tpl.js');

require('./components/track/mapping/betoTrackMapping.js');

require('./components/track/mapping/groupMap.tpl.js');

require('./components/track/mapping/groupMapController.js');

require('./components/track/reports/betoTrackReports.js');

require('./components/track/reports/betoTrackReports.tpl.js');

require('./components/track/reports/groupDetailReport.tpl.js');

require('./components/track/reports/groupDetailReportController.js');

require('./components/track/reports/groupSummary.tpl.js');

require('./components/track/reports/groupSummaryReportController.js');

require('./components/track/reports/performance.tpl.js');

require('./components/track/reports/performanceReportController.js');

require('./components/track/reports/reportService.js');

require('./components/track/reports/vehicleDetailReport.tpl.js');

require('./components/track/reports/vehicleDetailReportController.js');

require('./components/track/reports/workingHoursDatevDialog.tpl.js');

require('./components/track/reports/workingHoursDatevDialogController.js');

require('./components/track/telephone/deleteConfirm.tpl.js');

require('./components/track/telephone/deleteController.js');

require('./components/track/telephone/download.tpl.js');

require('./components/track/telephone/pendingCommandController.js');

require('./components/track/telephone/pendingCommandService.js');

require('./components/track/telephone/telephone.js');

require('./components/track/telephone/telephone.tpl.js');

require('./components/track/telephone/telephoneEditController.js');

require('./components/track/telephone/telephoneImportDialog.tpl.js');

require('./components/track/telephone/telephoneImportDialogController.js');

require('./components/track/telephone/telephoneList.tpl.js');

require('./components/track/telephone/telephoneListController.js');

require('./components/track/telephone/telephoneOperate.tpl.js');

require('./components/track/telephone/telephoneService.js');

require('./components/track/track.rout.js');

require('./components/track/trackController.js');

//endinject



// WEBPACK FOOTER //
// ./.tmp/app.module.js